import React, { useEffect, useState } from "react";
import axios from "axios";
import Pulse from "react-reveal/Pulse";
import { FiArrowUp, FiArrowDown } from "react-icons/fi";

const BTCRate = () => {
  const [value, setValue] = useState(false);
  const [currency, setCurrency] = useState("");
  useEffect(() => {
    let timer = setInterval(getPrice, 5000) 
    
        return () => clearInterval(timer)

  }, );
  const getPrice = async () => {
    try{
    let res= await axios.get("https://min-api.cryptocompare.com/data/pricemulti?fsyms=BTC&tsyms=USD")
        const {data} = res
            const cryptos = data.BTC.USD;
            setCurrency(cryptos);
              if (cryptos >= currency) setValue(true);
              else setValue(false);
            
  }
  catch(err){
    console.log(err)
  }
}
  return (
    <div style={{ color: value ? "green" : "red" }}>
      {currency ? (
        <Pulse when={value}>
          <div className="d-flex align-items-center">
            <span className="mr-4">{` 1 BTC = $${currency}`}</span>
            <span>
              {value ? (
                <FiArrowUp size={22} color="#3dbf28" />
              ) : (
                <FiArrowDown size={22} color="red" />
              )}
            </span>
          </div>
        </Pulse>
      ) : (
        ""
      )}
    </div>
  );
};

export default BTCRate;
